<template>
  <div class="tr">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'tbl-row'
}
</script>
